import React from 'react';
import clsx from 'clsx';
import { Checkbox as MuiCheckbox } from '@material-ui/core';

import useStyles from './useStyles';

const Checkbox = props => {
  const classes = useStyles();

  return (
    <MuiCheckbox
      className={classes.button}
      disableRipple
      color="default"
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      {...props}
    />
  );
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/sharedComponents/Checkbox/Checkbox.js